import React from 'react';
import {classes, style} from './doppe-action-checkout-modal.st.css';
import {
    DoppeViewerModalPanel,
    DoppeViewerModalPanelLayout,
} from '../../../components/doppe-viewer-modal-panel/doppe-viewer-modal-panel';
import {FlexLayout} from '@wix/devzai-common-client';
import {
    DoppeViewerModalPanelHeader,
} from '../../../components/doppe-viewer-modal-panel-header/doppe-viewer-modal-panel-header';
import {DoppeViewerScrollView} from '../../../components/doppe-viewer-scroll-view/doppe-viewer-scroll-view';
import {
    DoppeViewerModalPanelSection,
} from '../../../components/doppe-viewer-modal-panel-section/doppe-viewer-modal-panel-section';
import {DoppeActionCheckoutView} from './doppe-action-checkout-view';
import {useObservable} from '@wix/devzai-utils-react';

export const DoppeActionCheckoutModal = React.memo(function DoppeActionCheckoutModal(
    props: DoppeActionCheckoutModal.Props,
) {

    useObservable(props.observableCheckoutDetails);
    const title = props.observableCheckoutDetails.getValue().checkoutTitle;

    return (
        <DoppeViewerModalPanel
            className={style(FlexLayout.column.default)}
            mobileLayout={DoppeViewerModalPanelLayout.FullScreen}
            desktopLayout={DoppeViewerModalPanelLayout.InnerCentered}
        >
            <DoppeViewerModalPanelHeader
                title={title}
                dismissButtonCallback={props.dismissButtonCallback}
            />
            <DoppeViewerScrollView className={style(FlexLayout.fillRemainingVerticalSpace)}>
                <DoppeViewerModalPanelSection className={style(FlexLayout.column.default)}>
                    <div className={style(classes.modalBody, FlexLayout.column.default)}>
                        <DoppeActionCheckoutView
                            onDone={props.onDone}
                            actionContext={props.actionContext}
                            observableCheckoutDetails={props.observableCheckoutDetails}
                            createStripePaymentIntent={props.createStripePaymentIntent}
                            saveCheckoutIntent={props.saveCheckoutIntent}
                            demoMode={props.demoMode}
                            isCustomAmount={props.isCustomAmount}
                        />
                    </div>
                </DoppeViewerModalPanelSection>
            </DoppeViewerScrollView>
        </DoppeViewerModalPanel>
    );
});

export namespace DoppeActionCheckoutModal {
    export interface Props extends DoppeActionCheckoutView.Props {
        dismissButtonCallback: () => void;
    }
}
